


import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Navbar from "./components/Navbar.js";
import Footer from "./components/Footer.js";

import Service from "./pages/Service.js";
import Training from "./pages/Training.js";
// import Courses from "./pages/Courses.js";
import Contact from "./pages/Contact.js";
import Home from "./pages/Home.js";
import CourseDetails from './pages/CourseDetails.js';

import './styles/tailwind.css';
import Team from './pages/Team.js';

export default function App() {

  return (
      <>
        <Router>
          <div className="min-h-screen flex flex-col ">
            <Navbar />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/service" element={<Service />} />
                <Route path="/training" element={<Training />} />
                {/* <Route path="/courses" element={<Courses />} /> */}
                <Route path="/team" element={<Team />} />
                <Route path="/courses/:slug" element={<CourseDetails />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </Router>
      </>
  );
}

